<template>
    <div class="uk-form-stacked">
        <form-select
                :label="$t('rubinred.ecommerce.orders.checkout.bank')"
                :validations="['required']"
                :value="value"
                :values="values"
                ref="select"
        ></form-select>
    </div>
</template>

<script>
  export default {
    props: {
      customer: {
        type: Boolean,
        required: true,
      },
      banks: {
        type: [Object, Array],
        required: true,
      },
    },
    computed: {
      values() {
        return Array.isArray(this.banks) ? {} : this.banks;
      },
      value() {
        return this.$store.state.checkout.payment.handlerData ? this.$store.state.checkout.payment.handlerData.bankCode : null
      },
    },
    methods: {
      validate() {
        return this.$refs.select.validateField().valid;
      },
      getData() {
        if (!this.validate()) {
          return false;
        }
        return {bankCode: this.$refs.select.getValue()};
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/GestpayMybankHandler.vue